export enum FileTypeEnum {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSM = 'application/vnd.ms-excel.sheet.macroEnabled.12',
  XLSB = 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  CSV = 'text/csv',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  TIFF = 'image/tiff',
  ZIP = 'application/zip',
}

interface UploadConfig {
  [key: string]: {
    allowedFileTypes: FileTypeEnum[];
    message: string;
  };
}

export const uploadConfig: UploadConfig = {
  general: {
    allowedFileTypes: [],
    message: '',
  },
  dealDocuments: {
    allowedFileTypes: [
      FileTypeEnum.PDF,
      FileTypeEnum.JPEG,
      FileTypeEnum.TIFF,
      FileTypeEnum.XLS,
      FileTypeEnum.XLSX,
      FileTypeEnum.XLSM,
      FileTypeEnum.XLSB,
      FileTypeEnum.CSV,
    ],
    message:
      'PDF, JPEG, TIFF, Excel (.xls, .xlsx, .xlsm, .xlsb), and CSV files are allowed for upload.',
  },
  collateralDocuments: {
    allowedFileTypes: [FileTypeEnum.PDF],
    message: 'Only PDF files are allowed for upload.',
  },
  settlementDocuments: {
    allowedFileTypes: [FileTypeEnum.PDF],
    message: 'Only PDF files are allowed for upload.',
  },
  wireConfirmationDocuments: {
    allowedFileTypes: [FileTypeEnum.PDF],
    message: 'Only PDF files are allowed for upload.',
  },
  diligenceZip: {
    allowedFileTypes: [FileTypeEnum.ZIP],
    message: 'Only .zip files are allowed for upload.',
  },
  stipulationsDocuments: {
    allowedFileTypes: [FileTypeEnum.DOC, FileTypeEnum.DOCX, FileTypeEnum.PDF, FileTypeEnum.JPEG],
    message: 'Only .doc, .docx, .pdf and .jpeg files are allowed for upload.',
  },
};
